import {Component, EventEmitter, Input, OnDestroy, Output, TemplateRef} from '@angular/core';
import {NavigationService} from "../../../service/services/misc/navigation/navigation.service";
import {FullscreenService} from "../../../core/components/core/fullscreen/fullscreen.service";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs";


@Component({
    selector: 'app-full-screen-button',
    templateUrl: './full-screen-button.component.html',
    styleUrls: ['./full-screen-button.component.scss'],
    standalone: false
})
export class FullScreenButtonComponent implements OnDestroy {

    isFullScreen = false;
  @Input() body: TemplateRef<any>;

  @Input() headerTitle: string;
  @Input() iconType: string;
  @Input() rightHeaderContent: TemplateRef<any>;
  @Input() selector: string;
  @Output() clickEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() isExpand = true;
  subscriptions: Subscription[] = [];

  constructor(private navigationService: NavigationService, private fullscreenService: FullscreenService, private route: ActivatedRoute) {
      this.subscriptions.push(this.subscribeToUrlChange());
      this.subscriptions.push(this.pageFullscreenEventListener());

  }

  toggleFullScreen() {
      this.isFullScreen = !this.isFullScreen;
      this.clickEvent.emit(true);
      const element = document.querySelector(this.selector);
      if (this.isExpand) {
          element?.classList.toggle('maximize-fullscreen');
      } else {
          element?.classList.remove('maximize-fullscreen');
          element?.classList.remove('maximize-fullscreen-condensed');
      }
  }

  subscribeToUrlChange() {
      return this.navigationService.getNavigationEvents(this.route).subscribe(() => {
          const element = document.querySelector(this.selector);
          element.classList.remove('maximize-fullscreen');
          element.classList.remove('maximize-fullscreen-condensed');
          this.clickEvent.emit(false);
      });
  }

  pageFullscreenEventListener(){
      return this.fullscreenService.getIsExpandedObservable().subscribe(() => {
          const element = document.querySelector(this.selector);
          if (!this.isFullScreen) {
              return;
          }
          if (this.fullscreenService.getIsExpanded()) {
              element?.classList.remove('maximize-fullscreen');
              element?.classList.add('maximize-fullscreen-condensed');
          }
          else {
              element?.classList.add('maximize-fullscreen');
              element?.classList.remove('maximize-fullscreen-condensed');
          }
      });
  }

  ngOnDestroy(): void {
      this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
